import { THEME_STORAGE_KEY, type ResolvedTheme, type ThemeMode } from './theme.type.ts';

/**
 * 테마 적용 로직의 단일 소스.
 * index.html 의 인라인 FOUC 스크립트와 동일한 규칙을 유지해야 한다
 * (저장값 우선 → 없으면 시스템 설정).
 */

const isBrowser = typeof window !== 'undefined';

export function getStoredTheme(): ThemeMode | null {
  if (!isBrowser) return null;
  try {
    const v = localStorage.getItem(THEME_STORAGE_KEY);
    return v === 'light' || v === 'dark' || v === 'system' ? v : null;
  } catch {
    return null;
  }
}

export function getSystemTheme(): ResolvedTheme {
  if (!isBrowser) return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

/** 저장된 모드를 실제 light/dark 로 해석 */
export function resolveTheme(mode: ThemeMode): ResolvedTheme {
  return mode === 'system' ? getSystemTheme() : mode;
}

/** <html> 에 .dark 클래스 토글 + color-scheme 지정 */
export function applyTheme(resolved: ResolvedTheme): void {
  if (!isBrowser) return;
  const root = document.documentElement;
  root.classList.toggle('dark', resolved === 'dark');
  root.style.colorScheme = resolved;
}

export function persistTheme(mode: ThemeMode): void {
  if (!isBrowser) return;
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    /* storage 비활성(시크릿 등) — 무시 */
  }
}
